import React from "react";
import classes from "./storeCheckoutLocatorModal.css";
import AvailableIcon from "../../AvailableIcon";
import { FormattedMessage } from 'react-intl';
var StoreBopisAvailability = _ref => {
  var {
    bopis_enabled,
    rootStyles,
    iconStyle
  } = _ref;
  return bopis_enabled === '1' ? /*#__PURE__*/React.createElement("div", {
    className: classes.bopis,
    style: rootStyles
  }, /*#__PURE__*/React.createElement(AvailableIcon, {
    type: 'check',
    style: iconStyle
  }), /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pickup.available",
    defaultMessage: "Buy online pick-up in store available at this location"
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.bopis,
    style: rootStyles
  }, /*#__PURE__*/React.createElement(AvailableIcon, {
    type: 'unavailable',
    style: iconStyle
  }), /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "pickup.unavailable",
    defaultMessage: "Buy online pick-up in store not available at this location"
  }));
};
export default StoreBopisAvailability;